import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import styled from 'styled-components';
import { FormControl, FormControlLabel, FormLabel, Switch } from '@material-ui/core';
var StyledToggleLabel = styled.div.withConfig({
  displayName: "Toggle__StyledToggleLabel",
  componentId: "sc-66z69h-0"
})(["display:flex;align-items:flex-end;"]);

var Toggle = function Toggle(_ref) {
  var disabled = _ref.disabled,
      dsOnChange = _ref.dsOnChange,
      e2e = _ref.e2e,
      required = _ref.required,
      label = _ref.label,
      checked = _ref.checked,
      name = _ref.name,
      value = _ref.value;
  var switchElem =
  /*#__PURE__*/
  // @ts-ignore
  React.createElement(Switch, _extends({
    disabled: disabled,
    required: required,
    checked: !!checked,
    name: name,
    onChange: dsOnChange,
    value: value,
    color: "primary"
  }, e2e && {
    inputProps: {
      'data-e2e': "".concat(e2e, "-input")
    }
  }));
  return /*#__PURE__*/React.createElement(FormControl, {
    required: required
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    disabled: disabled,
    label: /*#__PURE__*/React.createElement(StyledToggleLabel, null, label, /*#__PURE__*/React.createElement(FormLabel, null)),
    control: switchElem
  }));
};

export default Toggle;

try {
  Toggle.__docgenInfo = {
    description: '',
    displayName: 'Toggle',
    methods: [],
    props: {
      dsOnChange: {
        defaultValue: null,
        description: '',
        name: 'dsOnChange',
        required: false,
        type: {
          name: '(event: ChangeEvent<HTMLInputElement>, checked: boolean) => void'
        }
      },
      e2e: {
        defaultValue: null,
        description: '',
        name: 'e2e',
        required: false,
        type: {
          name: 'string'
        }
      },
      label: {
        defaultValue: null,
        description: '',
        name: 'label',
        required: true,
        type: {
          name: 'ReactNode'
        }
      },
      disabled: {
        defaultValue: null,
        description: 'If `true`, the switch will be disabled.',
        name: 'disabled',
        required: false,
        type: {
          name: 'boolean'
        }
      },
      name: {
        defaultValue: null,
        description: 'Name attribute of the `input` element.',
        name: 'name',
        required: false,
        type: {
          name: 'string'
        }
      },
      value: {
        defaultValue: null,
        description: 'The value of the component. The DOM API casts this to a string.\n' + 'The browser uses "on" as the default value.',
        name: 'value',
        required: false,
        type: {
          name: 'unknown'
        }
      },
      checked: {
        defaultValue: null,
        description: 'If `true`, the component is checked.',
        name: 'checked',
        required: false,
        type: {
          name: 'boolean'
        }
      },
      required: {
        defaultValue: null,
        description: 'If `true`, the `input` element will be required.',
        name: 'required',
        required: false,
        type: {
          name: 'boolean'
        }
      }
    }
  };
} catch (e) {}
//# sourceMappingURL=index.js.map